import { ChangeLanguage, Dropdown } from "@/components/shared";
import { Separator } from "@/components/ui/separator";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import CloseIcon from "./CloseIcon";
import MenuIcon from "./MenuIcon";

const Sidebar = () => {
  const t = useTranslations("common");

  return (
    <Sheet>
      <SheetTrigger className="data-[state=open]:hidden">
        <MenuIcon />
      </SheetTrigger>
      <SheetTrigger className="hidden data-[state=open]:block">
        <CloseIcon />
      </SheetTrigger>
      <SheetContent className="">
        <SheetTitle></SheetTitle>
        <Separator />
        <SheetDescription className=""></SheetDescription>
        <Dropdown
          className="mx-4"
          items={[
            {
              value: "1",
              trigger: t("floorPlans"),
              content: (
                <div className="flex flex-col gap-2 pl-10">
                  <SheetClose asChild>
                    <Link
                      className="text-ring text-lg"
                      href="/verkaufsoptimierte-grundrisse"
                    >
                      {t("salesOptimizedFloorPlans")}
                    </Link>
                  </SheetClose>
                  <SheetClose asChild>
                    <Link
                      className="text-ring text-lg"
                      href="/bemasste-grundrisse"
                    >
                      {t("sizedFloorPlans")}
                    </Link>
                  </SheetClose>
                  <SheetClose asChild>
                    <Link
                      className="text-ring text-lg"
                      href="/aufmass-service-vor-ort"
                    >
                      {t("measuringService")}
                    </Link>
                  </SheetClose>
                  <SheetClose asChild>
                    <Link
                      className="text-ring text-lg"
                      href="/individuelle-grundrisse"
                    >
                      {t("individual")}
                    </Link>
                  </SheetClose>
                  <SheetClose asChild>
                    <Link
                      className="text-ring text-lg"
                      href="/grundriss-designs"
                    >
                      {t("floorPlanDesigns")}
                    </Link>
                  </SheetClose>
                </div>
              ),
            },
            {
              value: "2",
              trigger: t("threeSixtyTour"),
              content: (
                <div className="flex flex-col gap-2 pl-10">
                  <SheetClose asChild>
                    <Link
                      className="text-ring text-lg"
                      href="/360-grad-rundgang"
                    >
                      {t("threeSixtyTour")}
                    </Link>
                  </SheetClose>
                  <SheetClose asChild>
                    <Link
                      className="text-ring text-lg"
                      href="/360-grad-matterport-service"
                    >
                      {t("threeSixtyTourService")}
                    </Link>
                  </SheetClose>
                </div>
              ),
            },
          ]}
        />
        <div className="mx-4">
          <Separator />
          <div className="px-10 py-4">
            <SheetClose asChild>
              <Link className="text-primary text-xl font-medium" href="/faq">
                FAQ&apos;s
              </Link>
            </SheetClose>
          </div>
          <Separator />
          <div className="px-10 py-4">
            <SheetClose asChild>
              <Link
                className="text-primary text-xl font-medium"
                href="/partner"
              >
                {"Partner"}
              </Link>
            </SheetClose>
          </div>
          <Separator />
          <div className="px-10 py-4">
            <SheetClose asChild>
              <Link className="text-primary text-xl font-medium" href="/preise">
                {t("prices")}
              </Link>
            </SheetClose>
          </div>
          <Separator />
          <div className="px-10 py-4">
            <SheetClose asChild>
              <Link
                className="text-primary text-xl font-medium"
                href="/impressum"
              >
                {t("contact")}
              </Link>
            </SheetClose>
          </div>
          <Separator />
        </div>

        <div className="flex w-full items-center justify-center py-7">
          <SheetClose asChild>
            <Link
              className="bg-primary border-primary lg:hover:bg-background lg:hover:text-primary flex items-center justify-center border-2 px-8 py-3 font-semibold tracking-wider text-white shadow-xs transition-all duration-400 *:h-5"
              href={"/login"}
            >
              Login
            </Link>
          </SheetClose>
        </div>

        <SheetFooter className="flex flex-wrap items-center justify-center gap-4">
          <SheetClose asChild>
            <Link className="text-ring text-sm underline" href="/impressum">
              {t("imprint")}
            </Link>
          </SheetClose>

          <SheetClose asChild>
            <Link className="text-ring text-sm underline" href="/datenschutz">
              {t("privacy")}
            </Link>
          </SheetClose>

          <SheetClose asChild>
            <Link className="text-ring text-sm underline" href="/agb">
              {t("terms")}
            </Link>
          </SheetClose>

          <ChangeLanguage />
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default Sidebar;
